import React from 'react';
import { Text } from '@chakra-ui/core';
import { getConsistentDateFormat } from '../../../../../utils/dateUtils';

interface LastModifiedCellProps {
  date: string | number | Date | null | undefined;
}

const LastModifiedCell: React.FC<LastModifiedCellProps> = ({ date }) => {
  const formattedDate = getConsistentDateFormat(date, 'full');

  return (
    <Text fontSize="sm" color="gray.600">
      {formattedDate}
    </Text>
  );
};

export default LastModifiedCell;
